import React, {ReactElement, ReactNode} from 'react';
import {useIntl} from 'react-intl';
import {getPageRoute} from '@fo/utils/routes/getPageRoute';
import {segmentEvents, track} from '@fo/shared-analytics/tracking/segment';
import {ESource, useRedirectToTide} from '@fo/shared-hooks/useRedirectToTide';

import Button, {ButtonVariant} from '../Button/Button';

export interface GetStartedButtonProps {
  buttonText?: ReactNode;
  url?: string;
  testId?: string;
  onClick?: () => void;
  isSkipQuoteFormAndRedirectToTide?: boolean;
  linkClassName?: string;
}

function GetStarted({
  buttonText,
  url,
  testId,
  onClick,
  isSkipQuoteFormAndRedirectToTide,
  linkClassName,
}: Readonly<GetStartedButtonProps>): ReactElement {
  const {formatMessage} = useIntl();
  const {redirectToTide} = useRedirectToTide();
  const getStartedButtonText = buttonText ?? formatMessage({id: 'apply.cta.getStarted'});
  const getStartedButtonUrl = (() => {
    if (url) {
      return url.includes(getPageRoute('quoteForm.start').replace(/\//g, '')) && isSkipQuoteFormAndRedirectToTide
        ? // set as undefined so the Button's onClick will be used instead
          undefined
        : // use Contentful's button url
          url;
    }
    return isSkipQuoteFormAndRedirectToTide ? undefined : getPageRoute('quoteForm.start');
  })();

  return (
    <Button
      ariaLabel={`${getStartedButtonText}`}
      href={getStartedButtonUrl}
      testId={testId || 'button.getStarted'}
      variant={ButtonVariant.CALL_TO_ACTION}
      className={linkClassName}
      onClick={() => {
        if (onClick) {
          onClick();
        } else {
          track(segmentEvents.ctas.getStarted, {button_text: getStartedButtonText});
        }
        if (isSkipQuoteFormAndRedirectToTide) {
          redirectToTide({source: ESource.FROM_CTA_TO_GET_STARTED});
        }
      }}
    >
      {getStartedButtonText}
    </Button>
  );
}

export default GetStarted;
